import { message } from 'antd';
import { queryApportionInfo } from '@api/finance/apportion';
import PageAdd from './PageAdd';

class Page extends PageAdd {
  componentDidMount() {
    this.getApportionInfo();
  }

  getApportionInfo = () => {
    queryApportionInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/apportion/PageEdit.js